import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Membership from "./pages/Membership";
import Schedule from "./pages/Schedule";
import Experience from "./pages/Experience";
import FAQ from "./pages/FAQ";
import CycleCoBasics from "./pages/CycleCoBasics";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function App() {
  return (
    <Router>
      <div
        className="min-h-screen flex flex-col"
        style={{ backgroundColor: "var(--color-complementary)" }}
      >
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/services" element={<Membership />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/experience" element={<Experience />} />
            <Route path="/experience/faq" element={<FAQ />} />
            <Route
              path="/experience/cyclecobasics"
              element={<CycleCoBasics />}
            />
            <Route
              path="/experience/privacypolicy"
              element={<PrivacyPolicy />}
            />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
